import React from 'react';
import PageWrapper from 'pages';

export class PageErrorType {
  public static readonly PAGE_NOT_FOUND = new PageErrorType('Not Found', '404 Not Found');

  public static readonly FORBIDDEN = new PageErrorType('Forbidden', '403 Forbidden');

  public static readonly PAGE_LOAD_FAILED = new PageErrorType(
    'The page can not be displayed.',
    'The page can not be displayed.'
  );

  public static readonly APP_LOAD_FAILED = new PageErrorType(
    'Error',
    'Failed to initialize the app. Please try again after a while.'
  );

  private constructor(public readonly title: string, public readonly content: string) {}
}

export enum PageErrorName {
  ChunkLoadError = 'ChunkLoadError',
}

interface PageErrorProps {
  error: PageErrorType;
}

export function PageError({ error }: PageErrorProps) {
  return (
    <PageWrapper title={error.title}>
      <div className='page-error'>
        {/* <div className='title'>{error.title}</div> */}

        <div className='page-error__content'>
          <p>{error.content}</p>
        </div>
      </div>
    </PageWrapper>
  );
}
